import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '../App';
import { AppStartupError } from '../shell/AppStartupError';
import { getAppConfig } from '../config';
import { createAppRouter } from '../router';

export function bootstrap(): void {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element "#root" not found.');
  }
  const root = createRoot(rootElement);

  try {
    const config = getAppConfig();
    const router = createAppRouter(config);
    root.render(
      <StrictMode>
        <App router={router} />
      </StrictMode>,
    );
  } catch (error) {
    root.render(
      <StrictMode>
        <AppStartupError error={error} />
      </StrictMode>,
    );
    // Todo: report(error) once RUM is wired here, per Observability rules
  }
}
